"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastsCopyToOfferedParamsSchema = void 0;
const zod_1 = require("zod");
/**
 * The schema that describes the parameters of copying forecasts into offered volumes.
 */
exports.ForecastsCopyToOfferedParamsSchema = zod_1.z.object({
    forecastIds: zod_1.z.number().array().min(1),
    startMonth: zod_1.z.string().regex(/^\d{4}-\d{2}$/),
    endMonth: zod_1.z.string().regex(/^\d{4}-\d{2}$/),
});
